import { SVGProps, Ref, forwardRef } from 'react';

export const FunnelOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.355 10.354V13.6h1.29v-3.246l5.455-7.7V2.4H1.9v.254zM.5 3.1l5.455 7.7V15h4.09v-4.2L15.5 3.1V1H.5z"
                fill="currentColor"
            />
        </g>
    </svg>
));
FunnelOutlinedSize16Glyph.displayName = 'FunnelOutlinedSize16Glyph';
